module.exports = __webpack_public_path__ + "static/client-management-bcc097f784e89702e68ebf77fae3b863.jpg";